import type { Rule } from 'ant-design-vue/es/form'
import type { ZodTypeAny } from 'zod'
import { auditRejectReasonSchema } from '@/schemas/fields/text'
import { zodFieldRule } from '@/utils/zodAntd'

/** 快捷：Zod schema → AntDV Rule（默认 change + blur） */
export function fieldRule(
  schema: ZodTypeAny,
  trigger: Rule['trigger'] = ['change', 'blur'],
  required = false,
): Rule {
  return zodFieldRule(schema, trigger, required)
}

/** 条件校验：满足 predicate 时才跑 schema */
export function fieldRuleWhen(
  schema: ZodTypeAny,
  predicate: () => boolean,
  trigger: Rule['trigger'] = ['change', 'blur'],
  required = false,
): Rule {
  return {
    ...(required ? { required: true } : {}),
    trigger,
    validator: async (_rule, value) => {
      if (!predicate()) return Promise.resolve()
      const r = schema.safeParse(value)
      if (!r.success) {
        return Promise.reject(new Error(r.error.issues[0]?.message ?? '校验失败'))
      }
      return Promise.resolve()
    },
  }
}

/** 审核驳回原因（条件必填） */
export function rejectReasonRuleWhen(isRejected: () => boolean, required = false): Rule {
  return fieldRuleWhen(auditRejectReasonSchema, isRejected, ['change', 'blur'], required)
}
